import React from "react";
import { Button, Spinner, Form, Container, Row, Col } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import Scanner from "./components/Scanner";
import {
  fetchArtists,
  fetchGenres,
  fetchLabels,
  fetchAlbums,
  fetchArchives,
} from "./services/DataService";
import "./style/volunteer.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

class Albums extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      filtered: [],
      searchTerms: [],
      print: false,
      archive: false,
      maxResults: 50,
    };
    this.albums = [];
    this.artists = {};
    this.genres = {};
    this.labels = {};
    this.onSearchChange = this.onSearchChange.bind(this);
    this.togglePrint = this.togglePrint.bind(this);
    this.onScan = this.onScan.bind(this);
    this.onDetected = this.onDetected.bind(this);
    this.scannerRef = React.createRef();
    this.timeout = null;
  }

  reduceIdName(map, obj) {
    map[obj.id] = obj.name;
    return map;
  }

  onScan() {
    this.setState({ scanning: !this.state.scanning }, () => {
      this.setState({ startScanner: this.state.scanning });
    });
  }

  onDetected(result) {
    this.setState({ scanning: !this.state.scanning }, () => {
      this.setState({ startScanner: this.state.scanning });
    });
    return this.setState({ redirect: `/albums/${result}` });
  }

  componentDidMount() {
    Promise.all([
      fetchArtists(),
      fetchGenres("0"),
      fetchLabels(),
      fetchAlbums(),
    ]).then(([artists, genres, labels, albums]) => {
      this.artists = artists.reduce(this.reduceIdName, {});
      this.genres = genres.reduce(this.reduceIdName, {});
      this.labels = labels.reduce(this.reduceIdName, {});
      this.albums = albums.map((album) => {
        album["artist"] =
          album.artist_id !== 0 ? this.artists[album.artist_id] : "Unknown";
        album["genre"] =
          album.genre_id !== 0 ? this.genres[album.genre_id] : "Unknown";
        album["label"] =
          album.label_id !== 0 ? this.labels[album.label_id] : "Unknown";
        return album;
      });
      this.setState({
        loading: false,
        filtered: this.albums.slice(0, this.state.maxResults),
      });
    });
  }

  togglePrint() {
    let filtered = this.albums;
    if (this.state.print) {
      filtered = filtered.filter((item) => item.print === this.state.print);
    }
    this.setState({
      filtered: filtered.slice(0, this.state.maxResults),
      loading: false,
    });
  }

  toggleArchive() {
    if (this.state.archive) {
      fetchArchives().then((albums) => {
        this.archives = albums.map((album) => {
          album["artist"] =
            album.artist_id !== 0 ? this.artists[album.artist_id] : "Unknown";
          album["genre"] =
            album.genre_id !== 0 ? this.genres[album.genre_id] : "Unknown";
          album["label"] =
            album.label_id !== 0 ? this.labels[album.label_id] : "Unknown";
          return album;
        });
        this.setState({
          loading: false,
          filtered: this.archives.slice(0, this.state.maxResults),
        });
      });
    } else {
      this.setState({
        loading: false,
        filtered: this.albums.slice(0, this.state.maxResults),
      });
    }
  }

  onSearchChange(event) {
    this.setState(
      { searchTerms: event.target.value.toLowerCase().split(" ") },
      this.applyFilters
    );
  }

  applyFilters() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let filtered = this.albums;
      let terms = this.state.searchTerms;
      terms.map((term) => {
        return (filtered = filtered.filter((item) =>
          `${item.title.toLowerCase()} ${item.artist.toLowerCase()} ${item.label.toLowerCase()} ${item.genre.toLowerCase()} ${
            item.date_kugs_released
          }`.includes(term)
        ));
      });
      this.setState({ filtered: filtered.slice(0, this.state.maxResults) });
    }, 800);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" className="kugs-spinner">
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.setState({ redirect: `/albums/${row.id}` });
      },
      onMouseEnter: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-enter";
      },
      onMouseLeave: (e, row, rowIndex) => {
        e.target.parentNode.className = "row-leave";
      },
    };

    return (
      <Container fluid>
        <Row>
          <Col md="2">
            <div className="count">{this.albums.length} Albums</div>
          </Col>
          <Col md="8">
            <div className="search-icon glyphicon glyphicon-search"></div>
            <Form.Control
              type="text"
              className="search-box"
              onChange={this.onSearchChange}
            />
            <Button
              variant="primary"
              onClick={() => {
                this.setState(
                  { print: !this.state.print, loading: true },
                  this.togglePrint
                );
              }}
              className={`glyphicon glyphicon-print btn-print ${
                this.state.print ? "active" : "inactive"
              }`}
            >
              <div className="hidden">Print Filter</div>
            </Button>
            <Button
              variant={`${this.state.archive ? "danger" : "primary"}`}
              onClick={() => {
                this.setState(
                  { archive: !this.state.archive, loading: true },
                  this.toggleArchive
                );
              }}
              className={`glyphicon glyphicon-book btn-print ${
                this.state.print ? "active" : "inactive"
              }`}
            >
              <div className="hidden">Archive Filter</div>
            </Button>
            <Button
              variant="primary"
              style={{ marginTop: "-10px", marginLeft: "20px" }}
              onClick={this.onScan}
              className={`glyphicon glyphicon-barcode btn-barcode`}
            >
              <div className="hidden">Barcode</div>
            </Button>
            {this.state.scanning ? (
              <div>
                <Button
                  variant="danger"
                  onClick={this.onScan}
                  className={`glyphicon glyphicon-remove btn-barcode-close`}
                >
                  <div className="hidden">Close QR Scanner</div>
                </Button>
                <div ref={this.scannerRef} className="barcode-preview">
                  <canvas
                    className="drawingBuffer"
                    style={{
                      position: "absolute",
                      top: "0px",
                    }}
                    width="640"
                    height="480"
                  />
                  {this.state.startScanner ? (
                    <Scanner
                      scannerRef={this.scannerRef}
                      onDetected={this.onDetected}
                    />
                  ) : null}
                </div>
              </div>
            ) : null}
          </Col>
          <Col md="2">
            <Button
              variant="primary"
              href="/albums/add"
              className="glyphicon glyphicon-plus btn-add"
            >
              <div className="hidden">Add</div>
            </Button>
          </Col>
        </Row>
        <BootstrapTable
          keyField="id"
          data={this.state.filtered}
          rowEvents={rowEvents}
          columns={[
            {
              dataField: "title",
              text: "Title",
              headerStyle: (column, colIndex) => {
                return { width: "26%" };
              },
            },
            {
              dataField: "artist",
              text: "Artist",
              headerStyle: (column, colIndex) => {
                return { width: "24%" };
              },
            },
            {
              dataField: "genre",
              text: "Genre",
              headerStyle: (column, colIndex) => {
                return { width: "18%" };
              },
            },
            {
              dataField: "date_kugs_released",
              text: "Date",
              headerStyle: (column, colIndex) => {
                return { width: "14%" };
              },
            },
            {
              dataField: "label",
              text: "Label",
              headerStyle: (column, colIndex) => {
                return { width: "18%" };
              },
            },
          ]}
        />
        <div className="list-message-bottom">
          Showing a limit of {this.state.maxResults} results
          <Button
            style={{ marginLeft: "1em" }}
            onClick={() =>
              this.setState(
                { maxResults: this.state.maxResults * 2 },
                this.applyFilters
              )
            }
            variant="primary"
          >
            Load More
          </Button>
        </div>
      </Container>
    );
  }
}

export default Albums;
